import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { FormControl, Validators } from '@angular/forms';
import { DialogService } from '../../../../shared/services/dialog.service';
import { Utility } from '../../../../common/utility';
import { AppMessages } from '../../../../shared/constants/messages';
import { AppConstants } from '../../../../shared/constants/constants';
import { ManageUser } from '../../../../models/centre/manage-user.model';
import { ConsultationType, ConsultationValue } from '../../../../models/consultation/consultation.model';
import { IndividualWaitingModel } from '../../../../models/waiting-room/individual-waiting.model';
import { ConsultationHistoryComponent } from '../../../consultation-history/consultation-history.component';
import { IndividualWaitingService } from './individual.service';
import { ConsultationStatusPopupComponent } from '../../consultation-status/consultation-status-popup';
import { TMBDataTableComponent } from '../../../../components/data-table/data-table.component';
import { SharedService } from '../../../../shared/services/share.services';
import { EditGroupPopupComponent } from '../group/edit-group-popup.component';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';

@Component({
  selector: 'app-individual-list',
  templateUrl: 'individual-list.component.html',
  providers: [IndividualWaitingService]
})
export class IndividualWaitingListComponent extends TMBDataTableComponent implements OnInit {
  public appConstants = AppConstants;
  public consultationValue = ConsultationValue;
  public dataRow = new Array<IndividualWaitingModel>();
  public selectedArr = [];
  @Output() changeSelectedPatient = new EventEmitter<any>();
  constructor(
    public utility: Utility,
    public individualWaitingService: IndividualWaitingService,
    public dialogService: DialogService,
    public sharedService: SharedService,
    private router: Router
  ) {
    super(sharedService);
  }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  setPage(pageInfo, isUpdateLastedDate = true) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1
    };
    this.individualWaitingService.getWaitingList(param, isUpdateLastedDate).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.page.totalElements = data['totalRecords'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          // update dataSource
          this.dataRow = data['list'];
          if (this.page.pageNumber + 1 > this.page.totalPages) {
            this.page.pageNumber = this.page.totalPages > 0 ? (this.page.totalPages - 1) : 0;
          }
          this.updateActiveStatus();
        }
      }
    );
  }

  clearSelectedPatient() {
    this.selectedArr = [];
  }

  updateActiveStatus() {
    for (let i = 0; i < this.dataRow.length; i++) {
      this.dataRow[i]['active'] = (this.selectedArr.filter(x => x.id === this.dataRow[i].id).length > 0) ? true : false;
    }
  }

  onRemovePatient(id: string) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.individualConsultant.removeUser }).subscribe(result => {
      if (result) {
        this.individualWaitingService.removePatientFromWaitingRoom(id).subscribe(
          (res) => {
            if (res) {
              this.reloadPage(this.page.pageNumber, this.dataRow, true);
              // remove patient from waiting room then must remove from selectedArr SD10001680-440
              this.removePatientFromSelectedArr(id);
            }
          }
        );
      }
    });
  }
  /**
     * Update user/permission information
     * @param string userId
     */
  onEditItem(row) {
    this.router.navigate(['centre/patient-information', row.userId]);
  }

  /**
     * navigate to account payment
     * @param string userId
     */
  onEditAccount(row) {
    this.router.navigate(['payment/account-payment'],
      {
        queryParams:
        {
          patientId: row.userId,
        }
      });
  }

  /**
    * Function show dialog consultation history
    */
  openConsultationHistory(row: any) {
    const height = window.screen.height - (window.screen.height * 25 / 100);
    const width = window.screen.width - (window.screen.width * 20 / 100);
    const data = {
      patientId: row.userId,
      id: row.id,
      height: height,
      width: width
    };
    this.dialogService.openComponentDialog(ConsultationHistoryComponent, data, {
      width: width + 'px',
      height: height + 'px'
    });
  }

  onSelectedPatientChange(row, event) {
    if (event.checked) {
      this.selectedArr.push(row);
    } else {
      this.removePatientFromSelectedArr(row.id);
    }
    this.changeSelectedPatient.emit(this.selectedArr);
  }

  /**
   * function to remove the patient from selectedArr
   * @param patientId
   */
  removePatientFromSelectedArr(patientId) {
    for (let i = 0; i < this.selectedArr.length; i++) {
      if (this.selectedArr[i].id === patientId) {
        this.selectedArr.splice(i, 1);
        i--;
      }
    }
  }

  onConsultationIndividual(row) {
    const data = {
      status: row.status,
      id: row.id,
      userId: row.userId,
      isIndividual: 'true',
      lastedStep: row.step,
      name: row.name,
      dateOfBirth: row.dateOfBirth,
      groupId: row.groupId
    };

    // Update Created date Consultation
    if (row.status == 1) {
      // alert('Update Created date');

      this.individualWaitingService.updateCreateDateConsultation(data.id, data).subscribe(
        (result) => {
          if (result) {
            // row
          }
        }
      );

    }

    this.dialogService.openComponentDialog(ConsultationStatusPopupComponent, data, { 'width': '400px' }).subscribe(
      (result) => {
        if (result) {
          // remove selected patient (fix bug EU-160)
          const index = this.selectedArr.findIndex(s => s.id === row.id);
          if (index >= 0) {
            this.selectedArr.splice(index, 1);
          }
          // reload the list
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      }
    );
  }

  onEditGroup(groupId: string) {
    let group = new GroupWaitingModel();
    group.groupId = groupId;
    const data = {
      groupId: group
    };
    this.dialogService.openComponentDialog(EditGroupPopupComponent, data, { 'width': '800px' }).subscribe
      (result => {
        if (result) {
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      });
  }

  /**
   * return row class if item isCovered
   * @param row
   */
  getRowClass(row) {
    return {
      'isBadDebt': row.isBadDebt === true
    };
  }

  refreshPage(isUpdateLastedDate = false) {
    this.setPage({ offset: this.page.pageNumber }, isUpdateLastedDate);
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/individual/individual-list.component.ts